import { Button } from "primereact/button";
import { Image } from "primereact/image";
import React from "react";
import { InputWithLabel } from "../components/ui/InputWithLabel";
import { useAuth } from "../auth/AuthProvider";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";

export function Login() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isLoginError, setIsLoginError] = React.useState(false);

  const auth = useAuth();

  const navigate = useNavigate();

  async function login() {
    const success = await auth.signIn(email, password);
    setIsLoginError(!success);

    if (success) {
      navigate("/");
    }
  }

  return (
    <div
      style={{ backgroundImage: "url('/container_bg.svg')" }}
      className="flex flex-1 w-screen h-screen bg-no-repeat bg-cover justify-center items-center"
    >
      <div className="rounded-xl bg-white flex flex-col shadow-md min-w-[330px]">
        <div
          style={{ backgroundImage: "url('/card_bg.svg')" }}
          className="pt-5 pb-3 bg-cover bg-no-repeat rounded-t-xl flex flex-col items-center"
        >
          <Image
            src="/logo_horizontal_white.webp"
            alt="logo"
            className="w-[200px] mt-8"
          />
          <Image
            src="/main_image.svg"
            alt="logo"
            className="w-full h-auto mx-auto mt-8"
          />
        </div>
        <div className="bg-white rounded-xl">
          <div className="pt-8 px-8 flex flex-col">
            <InputWithLabel
              label="Email"
              value={email}
              onChange={(v) => setEmail(v.target.value)}
            />
            <InputWithLabel
              label="Password"
              type="password"
              value={password}
              onChange={(v) => setPassword(v.target.value)}
            />
            {isLoginError && (
              <div className="text-red-500 text-sm mt-2">
                Invalid email or password
              </div>
            )}
          </div>

          <div className="flex justify-center">
            <Button
              label="Login"
              className="w-1/2 mt-8 mb-8"
              onClick={login}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
